import Vue from 'vue'
import VueRouter from 'vue-router'
import Component from 'vue-class-component'
import { GlobalController } from './shared/global/GlobalController'
import { JtCrud, JtReportManager } from 'jtech-webcomps'
const CrudLayout = JtCrud.CrudLayout
const CrudLayoutSearch = JtCrud.CrudLayoutSearch
import InitPage from 'src/modules/layout/InitPage.vue'
import { routes as moduleRoutes } from './modules/routes'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
])

Vue.use(VueRouter)

const loadView = view => {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `src/${view}.vue`)
}

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '*',
      component: loadView('pages/Error404'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/mainLayout',
      name: 'mainLayout',
      component: loadView('modules/layout/MainLayout'),
      beforeEnter: ifAuthenticated,
      redirect: {
        name: 'initPage'
      },
      children: [
        {
          path: 'start',
          name: 'initPage',
          component: InitPage,
          props: true
        },
        {
          path: ':link',
          name: 'componenteCrudSearch',
          component: CrudLayoutSearch,
          props: true
        },
        {
          path: ':link',
          name: 'componenteCrud',
          component: CrudLayout,
          props: true
        },
        {
          path: 'report/:link',
          name: 'reportManager',
          component: JtReportManager,
          props: true
        },
        ...moduleRoutes
      ]
    },
    {
      path: '/',
      name: 'login',
      component: loadView('modules/login/Login')
    },
    {
      path: '/password',
      name: 'password',
      component: loadView('modules/login/password/Password')
    }
  ]
})
